import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import ConfirmDialog from 'ui/components/ConfirmDialog/ConfirmDialog'

type DiscardCopyDialogProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
}

export function DiscardCopyDialog({ open, onClose, onConfirm }: DiscardCopyDialogProps): ReactNode {
  const { t } = useTranslation()

  return (
    <ConfirmDialog
      open={open}
      initialFocus="deny"
      onClose={onClose}
      onConfirm={onConfirm}
      textObject={{
        title: t(`Do you really want to discard the copy?`),
        text: t(`The changes you made to the copy are lost, and the original setting is shown again.`),
      }}
    />
  )
}
